<template>
  <div>
    <Modal :hidden-nav="true" v-bind="$attrs" @close="handleClose" title="Contact Support">
      <div class="form-content">
        <div class="title">{{ $t("contactForm.title") }}</div>
        <div class="step">
          <div v-if="step < 1" class="step-item">
            <span>1</span>
          </div>
          <img v-else src="@/assets/icon_edit.png" alt="" />
          <div class="line"></div>
          <div v-if="step < 2" class="step-item">
            <span>2</span>
          </div>
          <img v-else src="@/assets/icon_edit.png" alt="" />
          <div class="line"></div>
          <div class="step-item">
            <span>3</span>
          </div>
        </div>
        <FormFirst @nextForm="formChange" ref="form" v-if="step === 0" />
        <FormSecond @nextForm="formChange" ref="form" v-else-if="step === 1" />
        <FormThird @nextForm="formChange" ref="form" v-else-if="step === 2" />
      </div>
    </Modal>
    <modal-success @close="success = false" :show="success" />
  </div>
</template>

<script>
import Modal from "../Modal/index.desktop";
import FormFirst from "./components/FormFirst.desktop";
import FormSecond from "./components/FormSecond.desktop";
import FormThird from "./components/FormThird.desktop";
import ModalSuccess from "@/components/ModalSuccess";
import { sendContact } from "@/api/home";
export default {
  name: "ModalTips",
  props: ["baseFormData"],
  components: { ModalSuccess, Modal, FormFirst, FormSecond, FormThird },
  data() {
    return {
      success: false,
      form: {
        first: [],
        second: {},
        third: {},
      },
      step: 0,
      checkList: [
        {
          id: "item1",
          label: this.$t("contactForm.checkList")[0],
        },
        {
          id: "item2",
          label: this.$t("contactForm.checkList")[1],
        },
        {
          id: "item3",
          label: this.$t("contactForm.checkList")[2],
        },
      ],
    };
  },
  methods: {
    formChange(name, data) {
      this.form[name] = data;
      if (name === "third") {
        const { first: demand, second, third } = this.form;
        const data = {
          ...this.baseFormData,
          demand,
          ...second,
          ...third,
        };
        sendContact(data).then((res) => (this.success = true));
        this.handleClose();
        return undefined;
      }
      this.step += 1;
    },
    next(data) {
      console.log(data);
      // if()
      // this.step += 1;
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.form-content {
  text-align: center;
  padding: 0 24px 24px;
  // padding: 127px 0 44px 0;
  & > .title {
    font-weight: 600;
    font-size: 24px;
    line-height: 34px;
    /* identical to box height */

    text-align: center;

    color: #ffffff;
    margin-bottom: 40px;
    @media screen and(max-width: 450px) {
      font-size: 24px;
      line-height: 34px;
    }
  }

  .step {
    display: flex;
    padding: 0 111px;
    justify-content: space-between;
    align-items: center;
    @media screen and(max-width: 450px) {
      padding: 0;
    }
    &-item {
      background: linear-gradient(135deg, #d3be8c 0%, #c2a061 100%);
      width: 46px;
      height: 46px;
      border-radius: 50%;
      font-weight: 600;
      font-size: 24px;
      color: #ffffff;
      line-height: 46px;
      @media screen and(max-width: 450px) {
        font-size: 16px;
        width: 32px;
        line-height: 32px;
        height: 32px;
      }
    }
    .line {
      width: 84px;
      height: 1px;
      background: #ffd591;
      left: 100%;
      top: 50%;
    }
  }
}
</style>
